/**
 * Static fallback version — used when the DB is unreachable.
 * The authoritative version lives in admin_settings (key: podgo_version).
 */
export const PODGO_VERSION_FALLBACK = "1.0.0";
